// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import IconAngleDown from "@rpsc/XDL/Icons/IconAngleDown";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { xBaseTheme } from "@rpsc/XDL/types";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,

        cssOverrides: {
            list: css`
                width: 100%;
                transform: translate(0, -4px);
                border: 1px solid ${color("common.black")};
                box-shadow: none;
                border-radius: 2px;
            `,
            dropdownWrapper: css`
                && input[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                    padding-left: 9px;
                }
                & input[disabled] ~ ${IconWrapper} {
                    color: ${color("common.border")};
                }
            `,
            selectedText: css`
                padding: ${({ _sizeVariant }: any) => (_sizeVariant === "small" ? "5px 9px" : "9px")};
                font-size: 14px;
                line-height: 19px;
            `,
            option: css`
                font-size: 16px;
                font-weight: ${fontConfig.weight.regular};
                letter-spacing: 0;
                line-height: 26px;
                color: ${color("text")};
                background: ${color("common.white")};
                padding: 8px;
                &:hover {
                    background: ${color("common.ui9")};
                }
                &[disabled],
                &[disabled] ~ ${IconWrapper} {
                    opacity: 0.33;
                }
            `,
            inputSelect: css`
                box-shadow: none;
                ${xScreen("lte", "xs")} {
                    font-size: 16px;
                }
            `,
        },
        iconProps: {
            color: "text.link",
            src: IconAngleDown,
            size: 13,
            css: css`
                width: 11px;
                &&& {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 9px;
                    width: auto;
                }
                svg {
                    width: 11px;
                    height: 13px;
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
